import Vue from "vue"
import Vuex from "vuex"
import { apiBaseUrl, apiOrigin } from "@/config/api"
// /import Apart from './modules/apart'

Vue.use(Vuex)

const loadImg = (imgSrc) => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve(true)
    img.onerror = () => resolve(false)
    img.src = imgSrc
  })
}

const fetchJson = async (url) => {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${url}`)
  }
  return response.json()
}

export default new Vuex.Store({
  state: {
    baseDomain: apiOrigin,
    apiURL: apiBaseUrl,
    popupRequestIsActive: false,
    popupCookieIsActive: false,
    popupTermsIsActive: false,
    popupProjectCompleted: false,
    locationCategories: [],
    locationPoints: [],
    about: [],
    furnish: [],
    blocks: [
      {
        id: 1,
        streets: {
          top: "Садовнический переулок",
          bottom: "Внутренний двор",
          right: "Садовническая улица",
        },
      },
      {
        id: 2,
        streets: {
          top: "Садовническая набережная",
          bottom: "Внутренний двор",
          right: "Садовнический переулок",
        },
      },
      {
        id: 3,
        streets: {
          top: "Садовническая набережная",
          bottom: "Садовническая улица",
          right: "Внутренний двор",
        },
      },
      {
        id: 4,
        streets: {
          top: "Внутренний двор",
          bottom: "Садовническая улица",
          right: "Садовнический переулок",
        },
      },
      {
        id: 5,
        streets: {
          top: "Внутренний двор",
          bottom: "Садовническая улица",
          right: "Садовнический переулок",
        },
      },
    ],
    flats: [],
    flatStatuses: [],
    flatHovers: [],
    floors: [],
    parkingSlots: [],
    bookletFile: "",
    hidePrices: false,
    smartCaptchaSiteKey: "",
    contacts: {
      phone: "",
      email: "",
      address: "",
      address_sales: "",
      instagram: "",
    },
    activeFlat: 0,
    projectLoading: true,
  },
  actions: {
    async fetchStartData(ctx) {
      let preloadPhoto = []

      try {
        // home head and location map
        preloadPhoto.push(require("@/assets/img/home-photo.jpg"))
        preloadPhoto.push(require("@/assets/img/location-map-updated.jpg"))

        // facades
        preloadPhoto.push(require("@/assets/img/facades/new/1.2.svg"))
        preloadPhoto.push(require("@/assets/img/facades/new/2.2.svg"))
        preloadPhoto.push(require("@/assets/img/facades/new/3.2.svg"))
        preloadPhoto.push(require("@/assets/img/facades/new/4.2.svg"))
        preloadPhoto.push(require("@/assets/img/facades/new/5.2.svg"))

        // home
        preloadPhoto.push(require("@/assets/img/home/1.jpg"))
        preloadPhoto.push(require("@/assets/img/home/2.jpg"))
        preloadPhoto.push(require("@/assets/img/home/3.jpg"))
        preloadPhoto.push(require("@/assets/img/photo-samples/4.jpg"))
        preloadPhoto.push(require("@/assets/img/photo-samples/formats.jpg"))

        // about
        preloadPhoto.push(require("@/assets/img/about/1.jpg"))

        const baseParams = await fetchJson(apiBaseUrl + "params")
        ctx.commit("updateParams", baseParams)

        const about = await fetchJson(apiBaseUrl + "about")
        ctx.commit("updateAbout", about)

        const specials = await fetchJson(apiBaseUrl + "specials")
        ctx.commit("updateSpecials", specials)

        const furnish = await fetchJson(apiBaseUrl + "furnish")
        ctx.commit("updateFurnish", furnish)
        furnish.forEach((item) => {
          if (item.gallery && item.gallery.length) {
            item.gallery.forEach((photo) => {
              if (photo && photo.src) preloadPhoto.push(photo.src)
            })
          }
        })

        const flats = await fetchJson(apiBaseUrl + "flats")
        ctx.commit("updateFlats", flats)

        const floors = await fetchJson(apiBaseUrl + "floors")
        ctx.commit("updateFloors", floors)

        const flatHovers = await fetchJson(apiBaseUrl + "flat_hovers")
        ctx.commit("updateFlatHovers", flatHovers)

        const flatStatuses = await fetchJson(apiBaseUrl + "statuses")
        ctx.commit("updateFlatStatuses", flatStatuses)

        const locCategories = await fetchJson(
          apiBaseUrl + "location_categories"
        )
        ctx.commit("updateLocationCategories", locCategories)

        const locPoints = await fetchJson(apiBaseUrl + "location_points")
        ctx.commit("updateLocationPoints", locPoints)

        const documents = await fetchJson(apiBaseUrl + "documents")
        ctx.commit("updateDocuments", documents)

        const parkingSlots = await fetchJson(apiBaseUrl + "parking_slots")
        ctx.commit("updateParking", parkingSlots)

        await Promise.all(preloadPhoto.map((imageSrc) => loadImg(imageSrc)))
      } catch (error) {
        console.error("fetchStartData failed", error)
      } finally {
        ctx.commit("updateProjectLoading", false)
      }
    },

    setActiveFlat(ctx, id) {
      ctx.commit("updateActiveFlat", id)
    },

    changeRequestPopupActive(ctx, val) {
      ctx.commit("updateRequestPopupActive", val)
    },
    changeTermsPopupActive(ctx, val) {
      ctx.commit("updateTermsPopupActive", val)
    },
  },
  getters: {
    getApiUrl(state) {
      return state.apiURL
    },
    getBooklet(state) {
      return state.bookletFile
    },
    getLoadingStatus(state) {
      return state.projectLoading
    },
    getContacts(state) {
      return state.contacts
    },
    getAbout(state) {
      return state.about
    },
    getSpecials(state) {
      return state.specials
    },
    getParkingSlots(state) {
      return state.parkingSlots
    },
    getFlatStatuses(state) {
      return state.flatStatuses
    },
    getFlatHovers(state) {
      return state.flatHovers
    },
    getFlats(state) {
      return state.flats
    },
    getFloors(state) {
      return state.floors
    },
    getFurnish(state) {
      return state.furnish
    },
    getLocationCategories(state) {
      return state.locationCategories
    },
    getLocationPoints(state) {
      return state.locationPoints
    },
    getDocuments(state) {
      return state.documents
    },
    getPopupRequestIsActive(state) {
      return state.popupRequestIsActive
    },
    getPopupCookieIsActive(state) {
      return state.popupCookieIsActive
    },
    getPopupTermsIsActive(state) {
      return state.popupTermsIsActive
    },
    getPopupProjectCompleted(state) {
      return state.popupProjectCompleted
    },
    getActiveFlat(state) {
      return state.activeFlat
    },
    getSmartCaptchaSiteKey(state) {
      return state.smartCaptchaSiteKey
    },
  },
  mutations: {
    updateRequestPopupActive(state, val) {
      state.popupRequestIsActive = val
    },
    updateTermsPopupActive(state, val) {
      state.popupTermsIsActive = val
    },
    updateProjectCompleted(state, val) {
      state.popupProjectCompleted = val
    },
    updateProjectLoading(state, status) {
      state.projectLoading = status
    },
    updateParams(state, params) {
      state.contacts.phone = params.phone
      state.contacts.email = params.email
      state.contacts.connect = params.connect
      state.contacts.address = params.address
      state.contacts.address_sales = params.address_sales
      state.contacts.instagram = params.instagram
      state.contacts.telegram = params.telegram
      state.bookletFile = params.booklet_file
      state.hidePrices = params.hide_prices
      state.termsFile = params.terms_file
      state.smartCaptchaSiteKey = params.smartcaptcha_site_key || ""
    },
    updateAbout(state, about) {
      state.about = about
    },
    updateSpecials(state, specials) {
      state.specials = specials
    },
    updateParking(state, slots) {
      state.parkingSlots = slots
    },
    updateFurnish(state, furnish) {
      state.furnish = furnish
    },
    updateFlats(state, flats) {
      state.flats = flats
    },
    updateFloors(state, floors) {
      state.floors = floors
    },
    updateFlatHovers(state, hovers) {
      state.flatHovers = hovers
    },
    updateFlatStatuses(state, statuses) {
      state.flatStatuses = statuses
    },
    updateLocationCategories(state, categories) {
      state.locationCategories = categories
    },
    updateLocationPoints(state, points) {
      state.locationPoints = points
    },
    updateDocuments(state, documents) {
      state.documents = documents
    },
    updateActiveFlat(state, id) {
      state.activeFlat = id
    },
  },
  modules: {
    // apart
  },
})
